// @core/api/endpoints/project/start_sprint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SprintResponse,
  StartSprintRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Start sprint
 * Activates the sprint, locking the scope and beginning the countdown. Only one sprint can be active at a time per project.
 */
export async function StartSprint(
  project_id: string,
  sprint_id: string,
  data: StartSprintRequest,
  options?: RequestOptions
): Promise<SprintResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/sprints/:sprint_id/start`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':sprint_id', encodeURIComponent(sprint_id));
  const requestOptions = options;
  return client.post<SprintResponse>(requestPath, data, requestOptions);
}
